function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18 21H4c-.8 0-1.6-.3-2.1-.9-.6-.5-.9-1.3-.9-2.1v-4c0-.6.4-1 1-1s1 .4 1 1v4c0 .3.1.5.3.7.2.2.4.3.7.3h14c.3 0 .5-.1.7-.3s.3-.4.3-.7v-4c0-.6.4-1 1-1s1 .4 1 1v4c0 .8-.3 1.6-.9 2.1s-1.3.9-2.1.9z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 15c-.3 0-.5-.1-.7-.3l-5-5c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l4.3 4.3 4.3-4.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-5 5c-.2.2-.4.3-.7.3z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 15c-.6 0-1-.4-1-1V2c0-.6.4-1 1-1s1 .4 1 1v12c0 .6-.4 1-1 1z"
});
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref, _ref2, _ref3);
}
export default SvgDownload;